import { createElementBlock as t, openBlock as l, createElementVNode as n } from "vue";
const o = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-guest"
};
function s(r, e) {
  return l(), t("svg", o, e[0] || (e[0] = [
    n("path", {
      d: "M9 9C11.4862 9 13.5 6.98625 13.5 4.5C13.5 2.01375 11.4862 0 9 0C6.51375 0 4.5 2.01375 4.5 4.5C4.5 6.98625 6.51375 9 9 9ZM9 11.25C5.99625 11.25 0 12.7575 0 15.75V18H18V15.75C18 12.7575 12.0037 11.25 9 11.25Z",
      fill: "#555555",
      class: "svg__fill--medium-grey"
    }, null, -1)
  ]));
}
const c = { render: s };
export {
  c as default,
  s as render
};
